<script>
import { HorizontalBar } from "vue-chartjs";
import utils from "../../../services/utils";
export default {
  extends: HorizontalBar,
  props: ["bookName", "correct", "wrong"],
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        title: {
          display: true,
          text: this.bookName
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  },
  computed: {
    data() {
      return {
        labels: ["words"],
        datasets: [
          {
            label: "Correctly spelled",
            backgroundColor: utils.colors.green,
            data: [this.correct]
          },
          {
            label: "Incorrectly spelled",
            backgroundColor: utils.colors.red,
            data: [this.wrong]
          }
        ]
      };
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
};
</script>
